import classNames from 'classnames';
import React from 'react';
import LoadingSpin from '../LoadingSpin';
import './ssbutton.scss';
export default function SSButton(props) {
  const { isDisabled, type, btnText, onClickHandle, classBtn, showLoader } = props;
  const btnclass = classNames({ 'default-btn': true, 'btn-filled': type === 'filled' }, classBtn);
  return (
    <button
      className={btnclass}
      disabled={showLoader ? true : isDisabled}
      onClick={() => {
        if (isDisabled) {
          return;
        } else {
          onClickHandle && onClickHandle();
        }
      }}
      style={{
        background: isDisabled ? 'rgba(255, 255, 255, 0.3)' : '',
        border: isDisabled ? 'rgba(255, 255, 255, 0.3)' : '',
        cursor: isDisabled ? 'not-allowed' : '',
        height: isDisabled ? '40px' : '42px',
      }}
    >
      {showLoader ? <LoadingSpin /> : <span>{btnText}</span>}
    </button>
  );
}
